module.exports = __webpack_public_path__ + "static/media/steel.11503131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/steel.jpg
// module id = 640
// module chunks = 0